import { useNotification } from '@/common/composables/useNotification'
import { messagesService } from '@/services/messages/messages.service'

export const Messages = {
  /**
   * Показывает диалог ввода
   */
  showInput(title: string, placeholder: string): string | null {
    return prompt(title, placeholder)
  },

  /**
   * Диалог ввода текста (Swing `Messages.showInputText`).
   * 2-arg: (title, message) — message это надпись, поле пустое.
   * 3-arg: (message, title, def) — def в поле ввода.
   * Не использовать `prompt`: второй аргумент там default, не лейбл.
   */
  showInputText(
    titleOrMessage: string,
    messageOrTitle: string,
    def?: string,
  ): Promise<string> {
    if (def !== undefined) {
      return messagesService.showInputText(titleOrMessage, messageOrTitle, def)
    }
    return messagesService.showInputText(titleOrMessage, messageOrTitle)
  },

  /**
   * Показывает сообщение (Promise — для await в chainCalled / dialogClosed).
   */
  showMessage(text: string, title?: string): Promise<void> {
    const msg = String(text ?? '')
    const ttl = String(title ?? 'Сообщение')
    return messagesService.showMessage(msg, ttl).catch(() => {
      useNotification().info({
        summary: ttl,
        detail: msg,
      })
    })
  },

  /**
   * Показывает сообщение об ошибке (Promise — для await в скриптах).
   */
  showMessageError(text: string, title?: string): Promise<void> {
    const msg = String(text ?? '')
    const ttl = String(title ?? 'Ошибка')
    return messagesService.showMessageError(msg, ttl).catch(() => {
      useNotification().error({
        summary: ttl,
        detail: msg,
      })
    })
  },

  /**
   * Показывает диалог подтверждения.
   */
  showConfirmDialog(message: string, title: string): Promise<number> {
    return messagesService.showConfirmDialog(message, title)
  },

  /**
   * Показывает диалог подтверждения
   */
  checkConfirmation(text: string, title: string): boolean {
    return confirm(`${title}${text}`)
  },

  /**
   * Показывает диалог выбора кнопок
   */
  showButtonChooser(text: string, title: string, buttons: string[][]): string | undefined {
    const options = buttons.map((button, index) => `${index + 1} = ${button[1]}`).join('\n')
    const selected = prompt(`${title} \n${text} \n${options} \n`)
    return buttons[Number(selected) - 1]?.[0]
  },
}

export default Messages
